import { createElementObject, createLayerComponent, extendContext, updateMediaOverlay } from './core';
// import { LatLngBounds, ImageOverlay as LeafletImageOverlay } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { ImageOverlay as LeafletImageOverlayInstance, LatLngBoundsExpression } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { LeafletContextInterface, MediaOverlayProps } from './core';

const LatLngBounds = L.LatLngBounds;
const LeafletImageOverlay = L.ImageOverlay;

export interface ImageOverlayProps extends MediaOverlayProps {
    children?: ReactNode
    url: string
}

export const ImageOverlay = createLayerComponent(function createImageOveraly({ bounds, url, ...options }: ImageOverlayProps, ctx: LeafletContextInterface) {
    const overlay = new LeafletImageOverlay(url, bounds, options);
    return createElementObject(overlay, extendContext(ctx, {
        overlayContainer: overlay
    }));
}, function updateImageOverlay(overlay: LeafletImageOverlayInstance, props: ImageOverlayProps, prevProps: ImageOverlayProps) {
    updateMediaOverlay(overlay, props, prevProps);
    if (props.bounds !== prevProps.bounds) {
        const bounds: LatLngBoundsExpression = props.bounds instanceof LatLngBounds ? props.bounds : new LatLngBounds(props.bounds);
        overlay.setBounds(bounds);
    }
    if (props.url !== prevProps.url) {
        overlay.setUrl(props.url);
    }
});
